import React from 'react';
import {Field, FieldArray, reduxForm} from 'redux-form'
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';

import moment from 'moment'

import DeleteIcon from 'material-ui/svg-icons/action/delete';
import DoneIcon from 'material-ui/svg-icons/action/done';
import PersonIcon from 'material-ui/svg-icons/social/person';
import ForwardIcon from 'material-ui/svg-icons/content/forward';
import ReplyIcon from 'material-ui/svg-icons/content/reply';

import FlatButton from 'material-ui/FlatButton';
import * as colors from 'material-ui/styles/colors';

import FormLabel from '../../components/FormLabel'
import FormAutoComplete2 from '../../components/FormAutoComplete2'
import FormDatePicker from '../../components/FormDatePicker'
import FormText from '../../components/FormText'
import FormCostContents from '../../components/FormCostContents'
import FormLabelOrderAmmounts from '../../components/FormLabelOrderAmmounts'
import FormLabelClaimAmmounts from '../../components/FormLabelClaimAmmounts'
import FormClaimAmmounts from '../../components/FormClaimAmmounts'
import FormAmmountTotalLabel from '../../components/FormAmmountTotalLabel'
import CostCard from '../../components/CostCard'
import YosanLeaner from '../../components/YosanLeaner'
import * as commons from '../../commons';
import * as actions from '../../actions';
import styles from '../../styles'

import $ from 'jquery'

class YosanHistoryFormPage extends React.Component {

    constructor(props) {
        super(props)
    }

    handleNewRequest = (value, index) => {

        const {
            onKenmeiChange,
            kenmeiData
        } = this.props

        if (index === -1) {
            return
        }

        const kenmei = kenmeiData[index] || {}

        onKenmeiChange(
            {
                kenmeiName: kenmei.name,
                branchOfficeName: kenmei.branchOfficeName,
                departmentName: kenmei.departmentName,
                customerName: kenmei.customerName,
                constructionName: kenmei.constructionName,
                address: kenmei.address,
            }
        )

    }

    handleUpdateInput = (value) => {

        const {
            onKenmeiChange,
            kenmeiData
        } = this.props

        const kenmei = kenmeiData.find(x => {
            return x.code == value
        })

        if (kenmei) {
            onKenmeiChange(
                {
                    kenmeiName: kenmei.name,
                    branchOfficeName: kenmei.branchOfficeName,
                    departmentName: kenmei.departmentName,
                    customerName: kenmei.customerName,
                    constructionName: kenmei.constructionName,
                    address: kenmei.address,
                }
            )
        } else {
            onKenmeiChange(
                {
                    kenmeiName: "ー",
                    branchOfficeName: "ー",
                    departmentName: "ー",
                    customerName: "ー",
                    constructionName: "ー",
                    address: "ー",
                }
            )
        }

    }

    reduceAdd = (array, col) => {
        let num = 0
        if (array && array.length) {
            num = array.map(x => commons.toNumber(x[col])).reduce((a, b) => a + b)
        }
        return num
    }

    getOrderAmmount = (orderAmmount, orderAmmounts, col) => {
        return commons.toNumber(orderAmmount) + this.reduceAdd(orderAmmounts, col)
    }

    getAllBudget = (materialCosts, outsourcingCosts, roumuCosts, expenseCosts) => {
        return this.reduceAdd(materialCosts, 'budget') +
            this.reduceAdd(outsourcingCosts, 'budget') +
            this.reduceAdd(roumuCosts, 'budget') +
            this.reduceAdd(expenseCosts, 'budget')
    }

    getAllResult = (materialCosts, outsourcingCosts, roumuCosts, expenseCosts) => {
        return this.reduceAdd(materialCosts, 'result') +
            this.reduceAdd(outsourcingCosts, 'result') +
            this.reduceAdd(roumuCosts, 'result') +
            this.reduceAdd(expenseCosts, 'result')
    }

    costStyle = (kind, month, costOpens) => {

        let open = false
        for (let i = 0; i < costOpens.length; i++) {
            const costOpen = costOpens[i]
            if (costOpen.kind == kind && costOpen.month == month) {
                open = costOpen.open
                break;
            }
        }

        return {
            transition: '1s',
            opacity: open ? 1 : 0,
            width: open ? '60vw' : 0
        }

    }

    render() {

        const {
            auth,
            status,
            kenmeiData = [],
            userData = [],
            costData,
            materialCosts,
            outsourcingCosts,
            roumuCosts,
            expenseCosts,
            orderAmmounts,
            orderAmmount,
            orderAmmountBudget,
            kenmeiNames,
            claimAmmounts,
            claimAmmount,
            error,
            initialValues,
            handleSubmit,
            onFormRegistClick,
            onFormDeleteClick,
            onFormStatusClick,
            costOpens,
            onCostClick,
            materialCostHistorys,
            roumuCostHistorys,
            outsourcingCostHistorys,
            expenseCostHistorys
        } = this.props

        const userDataSource = userData ? userData.map(x => {
            return {
                textKey: `${x.name} - ${x.email}`,
                valueKey: x.name
            }
        }) : []

        const materialCostDataSource = costData ? costData.filter(x => x.kind === 1) : []
        const outsourcingDataSource = costData ? costData.filter(x => x.kind === 2).map(x => ({
            textKey: x.name,
            valueKey: x.name
        })) : []
        const roumuDataSource = costData ? costData.filter(x => x.kind === 3) : []
        const expenseDataSource = costData ? costData.filter(x => x.kind === 4) : []

        const allOrderAmmount = this.getOrderAmmount(orderAmmount, orderAmmounts, 'orderAmmount')
        const allOrderAmmountBudget = this.getOrderAmmount(orderAmmountBudget, orderAmmounts, 'orderAmmountBudget')
        const allBudget = this.getAllBudget(materialCosts, outsourcingCosts, roumuCosts, expenseCosts)
        const allResult = this.getAllResult(materialCosts, outsourcingCosts, roumuCosts, expenseCosts)

        const allClaimAmmount = this.getOrderAmmount(claimAmmount, claimAmmounts, 'claimAmmount')

        return (

            <form onSubmit={() => {
            }}>

                {error && <div><span style={{color: 'rgb(244, 67, 54)'}}>{error}</span></div>}

                <div className="row" style={{marginBottom: 30}}>
                    <div className="col-12">
                        <Paper style={styles.yosanContents}>
                            <h4 style={styles.yosanFormTitle}>件名情報</h4>
                            <Divider/>
                            <div className="row">

                                <div className="col-6">

                                    <FormLabel
                                        title='件名番号'
                                        name='test'
                                        value={initialValues.kenmeiCode}
                                    />

                                </div>

                                <div className="col-6">

                                    <FormLabel
                                        title='担当者'
                                        name='test'
                                        value={initialValues.user}
                                    />

                                </div>

                            </div>

                            <div className='row'>

                                <div className="col-6">

                                    <FormLabel
                                        title='工期（自）'
                                        name='test'
                                        value={moment(initialValues.startDate).format("YYYY/MM/DD")}
                                    />

                                </div>
                                {/* <div className="col-2" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
                  <div style={{ paddingBottom: 7 }}><span style={{ paddingBottom: 5, color: colors.grey600 }}>〜</span></div>
                </div> */}
                                <div className="col-6">
                                    <FormLabel
                                        title='工期（至）'
                                        name='test'
                                        value={moment(initialValues.endDate).format("YYYY/MM/DD")}
                                    />
                                </div>

                            </div>

                            <div className='row'>

                                <div className="col-12">

                                    <FormLabel
                                        title='件名名称'
                                        name='test'
                                        value={kenmeiNames.kenmeiName}
                                    />

                                </div>

                            </div>
                            <div className='row'>
                                <div className="col-6">
                                    <FormLabel
                                        title='支店'
                                        name='test'
                                        value={kenmeiNames.branchOfficeName}
                                        style={{width: '100%'}}
                                    />
                                </div>
                                <div className="col-6">
                                    <FormLabel
                                        title='部署'
                                        name='test'
                                        value={kenmeiNames.departmentName}
                                        style={{width: '100%'}}
                                    />
                                </div>
                            </div>

                            <div className='row'>
                                <div className="col-6">
                                    <FormLabel
                                        title='客先'
                                        name='test'
                                        value={kenmeiNames.customerName}
                                        style={{width: '100%'}}
                                    />
                                </div>
                                <div className="col-6">
                                    <FormLabel
                                        title='工事種別'
                                        name='test'
                                        value={kenmeiNames.constructionName}
                                        style={{width: '100%'}}
                                    />
                                </div>
                            </div>

                            <div className='row'>
                                <div className="col-12">
                                    <FormLabel
                                        title='工事現場'
                                        name='test'
                                        value={kenmeiNames.address}
                                        style={{width: '100%'}}
                                    />
                                </div>
                            </div>

                        </Paper>

                    </div>

                </div>

                <div className="row" style={{marginBottom: 30}}>

                    <div className="col-6">

                        <Paper style={styles.yosanContents}>
                            <h4 style={styles.yosanFormTitle}>見積り情報</h4>
                            <Divider/>

                            <div className='row'>
                                <div className="col-6">
                                    <FormLabel
                                        title='見積り番号'
                                        value={initialValues.estimateCode}
                                    />
                                </div>
                                <div className="col-6">
                                    <FormLabel
                                        title='見積り金額'
                                        value={commons.dispMoney(initialValues.estimateAmmount)}
                                    />
                                </div>
                            </div>

                        </Paper>

                    </div>
                </div>

                <div className="row" style={{marginBottom: 30}}>
                    <div className="col-6">
                        <Paper style={styles.yosanContents}>
                            <h4 style={{...styles.yosanFormTitle, marginBottom: 5}}>
                                受注金額情報
                            </h4>
                            <div style={{marginTop: 5, marginBottom: 5}}>
                                <span style={{color: colors.grey600, fontSize: 12}}>
                                    予：
                                    <span style={{fontSize: 25}}>
                                        {commons.dispMoney(allOrderAmmountBudget)}
                                    </span>
                                </span>
                                                <span style={{marginLeft: 20, color: colors.grey600, fontSize: 12}}>
                                    実：
                                    <span style={{fontSize: 25}}>
                                        {commons.dispMoney(allOrderAmmount)}
                                    </span>
                                </span>
                            </div>
                            <Divider/>

                            <div className='row'>
                                <div className="col-4">
                                    <FormLabel
                                        title='受注金額(予)'
                                        value={initialValues.orderAmmountBudget}
                                    />
                                </div>
                                <div className="col-4">
                                    <FormLabel
                                        title='受注金額(実)'
                                        value={initialValues.orderAmmount}
                                    />
                                </div>
                            </div>

                            <FormLabelOrderAmmounts fields={initialValues.orderAmmounts} />

                        </Paper>
                    </div>

                    <div className="col-6">
                        <Paper style={styles.yosanContents}>
                            <h4 style={{...styles.yosanFormTitle, marginBottom: 5}}>
                                請求金額情報
                            </h4>
                            <div style={{marginTop: 5, marginBottom: 5}}>
                                <span style={{color: colors.grey600, fontSize: 12}}>
                                    合計：
                                    <span style={{fontSize: 25}}>
                                        {commons.dispMoney(allClaimAmmount)}
                                    </span>
                                </span>
                            </div>
                            <Divider/>

                            <div className='row'>
                                <div className="col-4">
                                    <FormLabel
                                        title='請求金額'
                                        value={initialValues.claimAmmount}
                                    />
                                </div>
                                <div className="col-4">
                                    <FormLabel
                                        title='備考'
                                        value={initialValues.claimComment}
                                    />
                                </div>
                            </div>

                            <FormLabelClaimAmmounts fields={initialValues.claimAmmounts} />

                        </Paper>
                    </div>

                </div>

                <div className="row" style={{marginBottom: 30}}>
                    <div className="col">
                        <Divider/>
                    </div>
                </div>

                <div className="row" style={{marginBottom: 30}}>

                    <div className="col-4">
                        <Paper style={styles.yosanContents}>

                            <h4 style={styles.yosanFormTitle}>利益 (予算)</h4>

                            <Divider/>

                            <FormAmmountTotalLabel title='受注金額' total={allOrderAmmountBudget}/>
                            <FormAmmountTotalLabel title='費用' total={allBudget}/>
                            <FormAmmountTotalLabel title='粗利益'
                                                   total={
                                                       allOrderAmmountBudget === 0 ? 'ー' :
                                                           allOrderAmmountBudget - allBudget
                                                   }
                                                   color
                            />
                            <FormAmmountTotalLabel title='粗利益率'
                                                   total={
                                                       allOrderAmmountBudget === 0 ? 'ー' :
                                                           Math.floor((allOrderAmmountBudget - allBudget) / allOrderAmmountBudget * 100)
                                                   }
                                                   addContents={
                                                       allOrderAmmountBudget === 0 ? '' :
                                                           (<span style={{
                                                               fontSize: 20,
                                                               color: colors.grey600
                                                           }}>&nbsp;%</span>)
                                                   }
                                                   color
                            />

                        </Paper>
                    </div>

                    <div className="col-4">

                        <Paper style={styles.yosanContents}>

                            <h4 style={styles.yosanFormTitle}>利益 (実績)</h4>

                            <Divider/>

                            <FormAmmountTotalLabel title='受注金額' total={allOrderAmmount}/>
                            <FormAmmountTotalLabel title='費用' total={allResult}/>
                            <FormAmmountTotalLabel title='粗利益'
                                                   total={
                                                       allOrderAmmount === 0 ? 'ー' :
                                                           allOrderAmmount - allResult
                                                   }
                                                   color
                            />
                            <FormAmmountTotalLabel title='粗利益率'
                                                   total={
                                                       allOrderAmmount === 0 ? 'ー' :
                                                           Math.floor((allOrderAmmount - allResult) / allOrderAmmount * 100)
                                                   }
                                                   addContents={
                                                       allOrderAmmount === 0 ? '' :
                                                           (<span style={{
                                                               fontSize: 20,
                                                               color: colors.grey600
                                                           }}>&nbsp;%</span>)
                                                   }
                                                   color
                            />

                            <FormAmmountTotalLabel title='達成率'
                                                   total={
                                                       (allOrderAmmountBudget - allBudget) <= 0
                                                           ? 'ー' :
                                                           Math.floor((allOrderAmmount - allResult) / (allOrderAmmountBudget - allBudget) * 100)
                                                   }
                                                   addContents={
                                                       (allOrderAmmountBudget - allBudget) <= 0
                                                           ? '' :
                                                           (<span style={{
                                                               fontSize: 20,
                                                               color: colors.grey600
                                                           }}>&nbsp;%</span>)
                                                   }
                                                   color
                            />

                        </Paper>
                    </div>


                    <div className="col-4">

                        <Paper style={styles.yosanContents}>

                            <h4 style={styles.yosanFormTitle}>利益 (実績)</h4>

                            <Divider/>

                            <FormAmmountTotalLabel title='受注金額' total={allOrderAmmount}/>
                            <FormAmmountTotalLabel title='費用' total={allResult}/>
                            <FormAmmountTotalLabel title='粗利益'
                                                   total={
                                                       allOrderAmmount === 0 ? 'ー' :
                                                           allOrderAmmount - allResult
                                                   }
                                                   color
                            />
                            <FormAmmountTotalLabel title='粗利益率'
                                                   total={
                                                       allOrderAmmount === 0 ? 'ー' :
                                                           Math.floor((allOrderAmmount - allResult) / allOrderAmmount * 100)
                                                   }
                                                   addContents={
                                                       allOrderAmmount === 0 ? '' :
                                                           (<span style={{
                                                               fontSize: 20,
                                                               color: colors.grey600
                                                           }}>&nbsp;%</span>)
                                                   }
                                                   color
                            />

                            <FormAmmountTotalLabel title='達成率'
                                                   total={
                                                       (allOrderAmmountBudget - allBudget) <= 0
                                                           ? 'ー' :
                                                           Math.floor((allOrderAmmount - allResult) / (allOrderAmmountBudget - allBudget) * 100)
                                                   }
                                                   addContents={
                                                       (allOrderAmmountBudget - allBudget) <= 0
                                                           ? '' :
                                                           (<span style={{
                                                               fontSize: 20,
                                                               color: colors.grey600
                                                           }}>&nbsp;%</span>)
                                                   }
                                                   color
                            />

                        </Paper>
                    </div>

                </div>

                <div className="row" style={{marginBottom: 30}}>
                    <div className="col">
                        <Divider/>
                    </div>
                </div>

                <div className="row" style={{marginBottom: 30}}>
                    <div className="col">
                        <CostCard key={1} kind={'材料費'} monthCosts={materialCostHistorys}/>
                    </div>
                </div>

                <div className="row" style={{marginBottom: 30}}>
                    <div className="col">
                        <CostCard key={2}  kind={'外注費'} monthCosts={outsourcingCostHistorys}/>
                    </div>
                </div>

                <div className="row" style={{marginBottom: 30}}>
                    <div className="col">
                        <CostCard key={3}  kind={'労務費'} monthCosts={roumuCostHistorys} dataSource={roumuDataSource}/>
                    </div>
                </div>

                <div className="row" style={{marginBottom: 30}}>
                    <div className="col">
                        <CostCard key={4}  kind={'経費'} monthCosts={expenseCostHistorys}/>
                    </div>
                </div>

            </form>
        );
    }
};

YosanHistoryFormPage = reduxForm({
    form: 'yosanHistoryForm', // a unique identifier for this form
    enableReinitialize: true,
})(YosanHistoryFormPage)

export default YosanHistoryFormPage


// WEBPACK FOOTER //
// ./src/containers/yosan/YosanHistoryForm.js